function e(e){return e?decodeURIComponent(e).replace(/[^a-zA-Z0-9]/g,""):""}export{e as getEncodedName};
